<template>
  <v-snackbar v-model="show" :color="color" :timeout="timeout">
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        :color="color !== 'success' ? 'tertiary' : ''"
        :text="color == 'success' ? true : false"
        v-bind="attrs"
        @click="show = false"
      >
        {{ $t('general.snackbarComponent.labels.close_button_text') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { SNACKBAR_TIMEOUT } from '@leapsight/styleguide'
export default {
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'ui/setSnackbar') {
        this.text = state.ui.snackbar.text
        this.color = state.ui.snackbar.color
        this.timeout = state.ui.snackbar.timeout
          ? state.ui.snackbar.timeout
          : SNACKBAR_TIMEOUT
        this.show = true
      }
    })
  },
  data() {
    return {
      show: false,
      color: '',
      text: '',
      timeout: SNACKBAR_TIMEOUT
    }
  }
}
</script>
